import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Message, Grid, Row, Col, Input } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import InputForm from '../../components/forms/input/InputForm'
import {
  getProgressReportSubprojectClose,
  saveObjective,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function ProgressObjective({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressReportsId,
  setProgressReportsId = () => {},
  isRenderMentionOfmentor,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
  }, [_schema])

  const onSubmit = (data) => {
    console.log('data => ', data)
    console.log('formSchema => ', formSchema.values)

    // return false
    let newArr = []
    const actualResults_ = Object.keys(data).filter((key) =>
      key.startsWith('actualResults_')
    ).length

    for (let i = 0; i < actualResults_; i++) {
      let actualResultKey = `actualResults_${i}`
      let mentionOfmentorKey = `mentionOfmentor_${i}`

      let newRes = {
        id: formSchema.values[i].id || '',
        objective: formSchema.values[i].objective.label || '',
        targetedResult: formSchema.values[i].targetedResult.value || '',
        actualResults: data[actualResultKey] || '',
        projectObjectiveRefCode: formSchema.values[i].objective.projectObjectiveRefCode,
        mentionOfmentor: data[mentionOfmentorKey] || '',
      }
      newArr.push(newRes)
    }

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period,
      installmentPlanDetailId: installmentPlanId,
      changesObjectives: data.changesObjectives || '',
      sustainabilityCompletion: data.sustainabilityCompletion || '',
      request: newArr,
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveObjective(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.performanceResults?.objective)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <>
      <div style={{ paddingLeft: 50, paddingRight: 10, marginTop: -10 }}>
        <Panel header={formSchema.header} collapsible defaultExpanded bordered>
          {formSchema.values.map((item, index) => {
            return (
              <Panel
                header={`${index + 1}.  ${item?.objective?.label || ''}`}
                collapsible
                defaultExpanded
                key={index}
                style={{ marginTop: -20 }}
              >
                <div style={{ paddingLeft: 40, paddingRight: 25, marginTop: -10 }}>
                  <Grid fluid>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          borderStyle: 'solid solid solid solid',
                          textAlign: 'center',
                          fontWeight: 'bold',
                          borderWidth: '1px',
                          padding: 5,
                        }}
                      >
                        <div style={{ padding: 3 }}>{formSchema.input.targetedResult.label}</div>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          borderStyle: 'solid solid solid none',
                          textAlign: 'center',
                          fontWeight: 'bold',
                          borderWidth: '1px',
                          padding: 5,
                        }}
                      >
                        <div style={{ padding: 3 }}>{formSchema.input.actualResults.label}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          borderStyle: 'none solid solid solid',
                          borderWidth: '1px',
                          background: '#000000',
                        }}
                      >
                        <CKEditorBlankFrom
                          schema={formSchema.input.targetedResult}
                          value={item?.targetedResult?.value || ''}
                          name={`${formSchema.input.targetedResult.name}_${item.targetedResult.id}`}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          hideToolbar={true}
                          noControlLabel={true}
                          marginTopRow={'unset'}
                          disable={formSchema.input.targetedResult.disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          borderStyle: 'none solid solid none',
                          background: '#000000',
                          borderWidth: '1px',
                        }}
                      >
                        <CKEditorBlankFrom
                          schema={formSchema.input.actualResults}
                          value={item?.actualResults?.value || ''}
                          name={`${formSchema.input.actualResults.name}_${index}`}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          hideToolbar={true}
                          noControlLabel={true}
                          marginTopRow={'unset'}
                          disable={disabled}
                        />
                      </Col>
                    </Row>
                  </Grid>
                </div>

                <div style={{ paddingLeft: 40, paddingRight: 25, marginTop: 15 }}>
                  <Row>
                    <Col xs={24} sm={24} md={24}>
                      {isRenderMentionOfmentor && (
                        <CKEditorBlankFrom
                          schema={formSchema.input.mentionOfmentor}
                          value={item?.mentionOfmentor?.value || ''}
                          name={`${formSchema.input.mentionOfmentor.name}_${index}`}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          hideToolbar={true}
                          marginTopRow={'unset'}
                        />
                      )}

                      {item?.mentionOfmentor?.value && !isRenderMentionOfmentor && (
                        <Message
                          type="warning"
                          description={
                            <div
                              dangerouslySetInnerHTML={{
                                __html: 'ความคิดเห็นของพี่เลี้ยง : ' + item?.mentionOfmentor?.value,
                              }}
                            />
                          }
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </Panel>
            )
          })}

          {formSchema.changesObjectives && (
            <>
              <div style={{ paddingLeft: 60, paddingRight: 25, marginBottom: 20 }}>
                <Row>
                  <Col xs={24} sm={24} md={24}>
                    {!disabled ? (
                      <InputForm
                        schema={formSchema.changesObjectives}
                        // value={item.link}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        componentClass={'textarea'}
                      />
                    ) : (
                      <>
                        <b>{`${formSchema?.changesObjectives?.label || ''}`}</b>
                        <p>{`${formSchema?.changesObjectives?.value || ''}`}</p>
                      </>
                    )}
                  </Col>
                </Row>
              </div>
            </>
          )}

          {formSchema.sustainabilityCompletion && (
            <>
              <div style={{ paddingLeft: 60, paddingRight: 25, marginBottom: 20 }}>
                <Row>
                  <Col xs={24} sm={24} md={24}>
                    {!disabled ? (
                      <InputForm
                        schema={formSchema.sustainabilityCompletion}
                        // value={item.link}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        componentClass={'textarea'}
                      />
                    ) : (
                      <>
                        <b>{`${formSchema?.sustainabilityCompletion?.label || ''}`}</b>
                        <p>{`${formSchema?.sustainabilityCompletion?.value || ''}`}</p>
                      </>
                    )}
                  </Col>
                </Row>
              </div>
            </>
          )}
          {!disabled && (
            <Row>
              <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                  <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                    บันทึก
                  </SaveButton>
                </div>
              </Col>
            </Row>
          )}
        </Panel>
      </div>
    </>
  )
}
